import "./auth-split-layout.scss";

import { ReactNode, useEffect } from "react";

export interface AuthSplitLayoutProps {
  readonly children: ReactNode;
  readonly className?: string;
}

const BODY_CLASS = "auth-split-layout";

export default function AuthSplitLayout({ children, className }: AuthSplitLayoutProps) {
  useEffect(() => {
    document.body.classList.add(BODY_CLASS);
    return () => {
      document.body.classList.remove(BODY_CLASS);
    };
  }, []);

  return <div className={className ? `auth-split ${className}` : "auth-split"}>{children}</div>;
}
